export default "__VITE_ASSET__BKYqZFvK__"